import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {getUnlikes} from "./unlikesAPI";

const initialState = {
    videoDetails: {},
    isLoading: false,
    isError: false,
    error: "",
}

// // async thunk
// export const fetchLikes = createAsyncThunk(
//     "likes/fetchLikes",
//     async (id, likesLocal) => {
//         console.log("likeSliceConsole", likesLocal);
//         const likesNumber = await getLikes(id, likesLocal);
//         return likesNumber;
//     }
// );

// async thunk
export const updateUnlikes = createAsyncThunk(
    "unlikes/updateUnlikes",
    async (obj) => {
        // console.log(obj);
        const response = await getUnlikes(obj);
        return response;
    }
);

const unlikessSlice = createSlice({
    name: 'likes',
    initialState,
    extraReducers: (builder) => {
        builder
            .addCase(updateUnlikes.pending, (state) => {
                state.isError = false;
                state.isLoading = true;
            })
            .addCase(updateUnlikes.fulfilled, (state, action) => {
                state.isLoading = false;
                state.videoDetails = action.payload;
            })
            .addCase(updateUnlikes.rejected, (state, action) => {
                state.isLoading = false;
                state.videoDetails = {};
                state.isError = true;
                state.error = action.error?.message;
            });
    },
});


export default unlikessSlice.reducer;